export default __webpack_public_path__ + "static/media/logo_white.7b38be3c.svg";